import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const Breadcrumb = () => {
  const { t } = useTranslation('eligibleStorageModule');

  const breadcrumbs = useMemo(
    () => [
      { label: t('breadcrumb.root', 'Facturación') },
      {
        label: <span className="text-title">{t('breadcrumb.eligibleStorage', 'Almacenamiento')}</span>,
      },
    ],
    [t],
  );

  usePageNavigation({ breadcrumbs });

  return null;
};
